import type { ReactNode } from 'react';
import styles from '../GeoBrowse.module.css';

type PageHeaderProps = {
  title: string;
  description?: string;
  backLink?: ReactNode;
  actions?: ReactNode;
};

export default function PageHeader({ title, description, backLink, actions }: PageHeaderProps) {
  return (
    <header className={styles.pageHeader}>
      <div className={styles.pageHeaderMain}>
        {backLink}
        <div>
          <h1 className={styles.pageTitle}>{title}</h1>
          {description && <p className={styles.pageDescription}>{description}</p>}
        </div>
      </div>
      {actions && <div className={styles.pageHeaderActions}>{actions}</div>}
    </header>
  );
}
